module.exports = __webpack_public_path__ + "static/media/room.fb6def45.svg";